
export enum ColumnAlingment
{
    START = 1, 
    CENTER = 2, 
    END = 3
}

export interface ITableDataSet {
    Columns: string[];
    Rows: string[][];
    Totals?: string[];
    ColumnsAlingments? : ColumnAlingment[];
}
